import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'DateAsUpcoming'
})
export class DateAsUpcoming implements PipeTransform {
  transform(value: any, isIonDate: boolean = false): any {
    if (value) {
      const localDate = isIonDate ? new Date(value) : new Date(value + 'Z');
      const seconds = Math.floor((+localDate - +new Date()) / 1000);

      if (seconds < 0) {
        return false;
      } else {
        const intervals: { [key: string]: number } = {
          'y': 31536000,
          'm': 2592000,
          'w': 604800,
          'd': 86400,
          'h': 3600,
          'min': 60,
          's': 1
        };
        let counter;
        for (const i in intervals) {
          counter = Math.floor(seconds / intervals[i]);
          if (counter > 0) {
            return counter + '' + i ; //+ (counter === 1 ? '' : 's')
          }
        }
      }
    }
    return value;
  }
}
